import moment from 'moment';
import qs from 'qs';
import { handleActions } from 'redux-actions';
import axios from 'axios';

import cloneDeep from 'lodash/cloneDeep';

import endpoints from '../../config/endpoints';
import intl from '../shared/intl';
import checkPermissions from '../shared/check-permissions';
import { default as createCalendar, getDateRangeFromCalendar } from '../shared/calendar';
import { actions as rootActions } from '../root';

const calendar = createCalendar({
	namespace: 'marketingReports',
	stateNodeName: 'calendar',
	defaultValue: {
		start: moment()
			.subtract('1', 'month')
			.format('YYYY-MM-DD'),
		end: moment().format('YYYY-MM-DD')
	}
});

const FETCH_DATA_SUCCESS = 'marketing-reports/fetch-data-success';
const TOGGLE_PROGRESS_BAR = 'marketing-reports/toggle-progress-bar';

const GET_BALANCES_SUCCESS = 'marketing-reports/get-balances-success';
const GET_BALANCES_ERROR = 'marketing-reports/get-balances-error';

export const allowedPermissions = {
	view: 'view_marketing_reports'
};

const initialState = {
	data: null,
	calendar: calendar.initialState,
	showProgressBar: false,
	error: false
};

export const actions = Object.assign({
	fetchData: () => dispatch => {
		setTimeout(() => dispatch({ type: FETCH_DATA_SUCCESS }), 1);
	},

	requestDeferredStatistics: () => (dispatch, getState) => {
		const email = getState().root.data.email;
		confirm(
			`Your request failed to process in 30 seconds. Request deferred report to be sent to email ${email}?`
		) && dispatch(actions.getReport(true));
	},

	getReport: (deferred = false) => (dispatch, getState) => {
		const { calendar } = getState().marketingReports;
		const date_range = getDateRangeFromCalendar(calendar);
		let url = `${endpoints.MARKETING_REPORTS.BASE}?${qs.stringify({date_range})}`;

		dispatch(rootActions.spinnerToggle());

		if (deferred) {
			url += '&is_deferred=1';
		}

		return axios({
			url,
			method: 'GET',
			responseType: 'blob'
		})
			.then(response => {
				dispatch(rootActions.spinnerToggle());

				if (deferred) {
					return false;
				}

				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				const startDate = moment(date_range.start).format('DD.MM.YYYY');
				const endDate = moment(date_range.end).format('DD.MM.YYYY');
				const filename = `ОСВ по поинтам за период с ${startDate} по ${endDate} .csv`;

				link.href = url;
				link.setAttribute('download', filename);
				document.body.appendChild(link);
				link.click();
			})
			.catch(() => {
				dispatch(rootActions.spinnerToggle());
				return dispatch(actions.requestDeferredStatistics());
			});
	},

	toggleProgressBar: () => ({
		type: TOGGLE_PROGRESS_BAR
	})

}, calendar.actions);

const reducers = Object.assign({
	[FETCH_DATA_SUCCESS]: state => ({ ...state, data: 'placeholder' }),
	[GET_BALANCES_SUCCESS]: (state, action) => ({ ...state, showProgressBar: false }),
	[TOGGLE_PROGRESS_BAR]: state => ({ ...state, showProgressBar: !state.showProgressBar }),
	[GET_BALANCES_ERROR]: state => ({ ...state, error: true })
}, calendar.reducers);

export default handleActions(reducers, cloneDeep(initialState));

export const selectors = {
	getData: state => state.marketingReports.data,
	getCalendar: state => calendar.selectors.getCalendar(
		state => state.marketingReports.calendar,
		state => state
	)(state),
	getIntl: state => intl(state),
	getProgressBar: state => state.marketingReports.showProgressBar,
	getCan: state => checkPermissions(state, allowedPermissions),
	getError: state => state.marketingReports.error
};


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/marketing-reports/index.js